module.exports = __webpack_public_path__ + "img/litloyal-demo5.6705a664.png";